import {REQUEST_TYPE} from '../../requests/constants/request-types.constant';
export class API {
  public static version = '/api/versions';
  public static fnVersion = '/api/fn/versions';
  public static uiVersion = '/assets/versions.txt';

  public static requestTypes = '/api/requests/types';
  public static paymentTypes = '/api/reference/request/card-production/payment-types';
  public static requestItemsTypes = '/api/reference/request/card-production/request-item-types';
  public static createNewRequest = '/api/requests';
  public static searchRequests = '/api/public/requests';

  public static searchUsersByUsernameFullMatch = '/api/public/users/search/usernames';
  public static getUsers = '/api/public/users/search';

  public static dataPINfileTypes = '/api/reference/request/card-production/data-pin-file-types';
  public static europeCountries = '/api/reference/request/countries/europe';
  public static getMerchants = '/api/reference/request/merchants';
  public static getContacts = '/api/public/contacts';
  public static redemptionTypes = '/api/reference/request/card-production/redemption-types';
  public static dielines = '/api/reference/request/card-production/dielines';
  public static substrates = '/api/reference/request/card-production/substrates';
  public static warehouses = '/api/reference/request/card-production/warehouses';
  public static requestAttachment(requestId: number, attachmentId: number) {
    return `/api/requests/${requestId}/stages/attachments/${attachmentId}`;
  }

  public static purchaseOrderApprovalTaskControllerSearchTasks = '/api/purchase-order-approval-tasks';
  public static purchaseOrderApprovalTaskControllerCollectSearchFilterOptions = '/api/purchase-order-approval-tasks/filter-options';
  public static purchaseOrderApprovalTaskControllerCollectGetTaskDetails = (purchaseOrderNumber: number) =>
    `/api/purchase-order-approval-tasks/${purchaseOrderNumber}`;
  public static purchaseOrderApprovalTaskControllerReviewPurchaseOrders = `/api/purchase-order-approval-tasks/reviews`;
  public static purchaseOrderApprovalTaskControllerReviewPurchaseOrder = (purchaseOrderNumber: number) =>
    `/api/purchase-order-approval-tasks/${purchaseOrderNumber}/reviews`;

  public static logout = '/api/logout';
  public static authorities = '/api/authorization/user/authorities';
  public static userDetails = '/api/authorization/user/details';
  public static darkModeChange = '/api/users/profiles/settings/display-mode';

  public static printers = '/api/reference/request/card-production/printers';
  public static companies = '/api/reference/request/card-production/companies';
  public static chnTypes = '/api/reference/request/card-production/chn-types';
  public static popChannelTypes = '/api/reference/request/pop/channel-types';
  public static inventoryTypes = '/api/reference/request/card-production/inventory-types';
  public static requestTypeInventoryTypes = (requestType: string) =>
    `/api/reference/request/inventory-types?requestType=${requestType}`;
  public static lineOfBusinessTypes = '/api/reference/request/card-production/line-of-business-types';
  public static designLineOfBusinessTypes = '/api/reference/request/design-line-of-business-types';
  public static regions = '/api/reference/request/card-design/regions';
  public static artLocationTypes = '/api/reference/request/card-design/art-location-types';
  public static designSourceTypes = '/api/reference/request/card-design/design-source-types';
  public static popItemTypes = '/api/reference/request/pop/item-types';
  public static colorTypes = '/api/reference/request/colors';
  public static dimensionTypes = '/api/reference/request/dimensions';
  public static financialTypes = '/api/reference/request/pop/financial-types';
  public static ppEventTypes = '/api/reference/request/pop-production/event-types';
  public static ppFundingTypes = '/api/reference/request/pop-production/funding-types';
  public static ppCuttingTypes = '/api/reference/request/pop-production/items/cutting-types';
  public static ppMaterialTypes = '/api/reference/request/pop-production/items/material-types';
  public static ppTapeTypes = '/api/reference/request/pop-production/items/tape-types';
  public static ppUsageDurationTypes = '/api/reference/request/pop-production/items/usage-duration-types';
  public static ppInventoryTypes = '/api/reference/request/pop-production/inventory-types';

  public static fsPaymentTypes = '/api/reference/request/financial-services/payment-types';
  public static fsComponentTypes = '/api/reference/request/financial-services/po/component-types';

  public static bifComponentTypes = '/api/reference/request/bif-production/component-types';
  public static bifFulfillmentTypes = '/api/reference/request/bif-production/fulfillment-types';

  public static thirdPartyOrderTypes = '/api/reference/request/third-party-production/items/order-types';
  public static thirdPartyDataPinFileTypes = '/api/reference/request/third-party-production/items/data-pin-file-types';
  public static thirdPartyPrintOwnerTypes = '/api/reference/request/third-party-production/print-owner-types';
  public static thirdPartyIssuer = '/api/reference/request/third-party-production/issuers/search';
  public static thirdPartyReturnFileTypes = '/api/reference/request/third-party-production/items/return-file-types';
  public static thirdPartyCompanies = '/api/reference/request/third-party-production/companies';

  public static ihComponents = '/api/reference/request/ih-production/components';
  public static ihPriorities = '/api/reference/request/ih-production/priorities';

  public static imageBrand = '/api/reference/request/image/brand/search';
  public static imageFormatTypes = '/api/reference/request/image/image-format-types';

  public static fileTypes = '/api/requests/attachments/types';

  // Reports
  public static reportsPopProduction = '/api/fn/reports/preview/pop-production-report';
  public static reportsPopProductionDownload = '/api/fn/reports/download/pop-production-report';
  public static reportsCreativeServices = '/api/fn/reports/preview/creative-services-report';
  public static reportsCreativeServicesDownload = '/api/fn/reports/download/creative-services-report/';
  public static reportsCreativeServicesFilters = '/api/fn/reports/aggregate-filters/creative-services-report';

  public static reportsShipping = '/api/fn/reports/preview/shipping-report';
  public static reportsShippingDownload = '/api/fn/reports/download/shipping-report/';
  public static reportsShippingFilters = '/api/fn/reports/aggregate-filters/shipping-report';

  public static reportsTrafficTracker = '/api/fn/reports/preview/traffic-tracker-report';
  public static reportsTrafficTrackerDownload = '/api/fn/reports/download/traffic-tracker-report/';
  public static reportsTrafficTrackerFilters = '/api/fn/reports/aggregate-filters/traffic-tracker-report';

  public static reportsSignedPo = '/api/signed-purchase-orders'; // @todo'/api/fn/reports/preview/shipping-report';
  // public static reportsShippingDownload = '/api/fn/reports/download/shipping-report/';
  public static reportsSignedPoFilters = '/api/signed-purchase-orders/filter-options';

  public static reportsPO = '/api/fn/reports/preview/po-report';
  public static reportsPODownload = '/api/fn/reports/download/po-report';
  public static reportsPOFilters = '/api/fn/reports/aggregate-filters/po-report';
  public static thirdParty = '/api/fn/reports/preview/third-party-report';
  public static thirdPartyDownload = '/api/fn/reports/download/third-party-report';
  public static thirdPartyFilters = '/api/fn/reports/aggregate-filters/third-party-report';
  public static production = '/api/fn/reports/preview/production-report';
  public static productionDownload = '/api/fn/reports/download/production-report';
  public static productionFilters = '/api/fn/reports/aggregate-filters/production-report';
  public static reportsIh = '/api/fn/reports/preview/ih-report';
  public static reportsIhDownload = '/api/fn/reports/download/ih-report';
  public static cardRanges = '/api/fn/reports/preview/card-ranges-report';
  public static cardRangesDownload = '/api/fn/reports/download/card-ranges-report';
  public static cardRangesFilters = '/api/fn/reports/aggregate-filters/card-ranges-report';
  // Reports End

  public static updateAttachmentStatus = {
    PRODUCTION_REQUEST: (requestId, requestItemId, attachmentId) =>
      `/api/requests/card-production/${requestId}/details/items/${requestItemId}/artworks/${attachmentId}`,
    POP_PRODUCTION_REQUEST: (requestId, requestItemId, attachmentId) =>
      `/api/requests/pop-production/${requestId}/items/${requestItemId}/printer-proofs/${attachmentId}/review`
  };

  public static updateRequestItemStatus = {
    PRODUCTION_REQUEST: (requestId, requestItemId) => `/api/requests/card-production/${requestId}/artworks/items/${requestItemId}/review`,
    PRODUCTION_REQUEST_3RD_PARTY: (requestId, requestItemId) =>
      `api/requests/third-party-production/${requestId}/items/${requestItemId}/artworks/review`,
    FINANCIAL_SERVICES_REQUEST: (requestId, requestItemId) =>
      `/api/requests/financial-services/${requestId}/items/${requestItemId}/artworks/review`,
    BIF_PRODUCTION_REQUEST: (requestId, requestItemId) =>
      `/api/requests/bif-production/${requestId}/items/${requestItemId}/printer-proofs/review`,
    [REQUEST_TYPE.PDR]: (requestId, requestItemId, isPrinterProofs, requestStage) =>
      `/api/requests/pop-design/${requestId}/items/${requestItemId}/financial-services-external-artworks/${requestStage}-review`,
    [REQUEST_TYPE.IPR]: (requestId, requestItemId, isPrinterProofs = false) =>
      `/api/requests/ih-production/${requestId}/items/${requestItemId}/${isPrinterProofs ? 'printer-proofs' : 'artworks'}/review`,
    [REQUEST_TYPE.PPR]: (requestId, requestItemId, isPrinterProofs = false) =>
      `/api/requests/pop-production/${requestId}/items/${requestItemId}/${isPrinterProofs ? 'printer-proofs' : 'artworks'}/review`
  };

  public static createExternalPin = {
    PRODUCTION_REQUEST: (requestId, itemId) => `/api/requests/card-production/${requestId}/items/${itemId}/external-pin-files`,
    PRODUCTION_REQUEST_3RD_PARTY: (requestId, itemId) =>
      `/api/requests/third-party-production/${requestId}/items/${itemId}/external-pin-files`
  };

  public static deleteExternalPin = {
    PRODUCTION_REQUEST: (requestId, attachmentId, itemId) =>
      `/api/requests/card-production/${requestId}/items/${itemId}/external-pin-files/${attachmentId}`,
    PRODUCTION_REQUEST_3RD_PARTY: (requestId, attachmentId, itemId) =>
      `/api/requests/third-party-production/${requestId}/items/${itemId}/external-pin-files/${attachmentId}`
  };

  public static IH_PRODUCTION_PRINTER = {
    getPrinterWorkItems: requestId => `/api/requests/ih-production/${requestId}/printers/work-items`,
    updateMilestoneDetails: (requestId, printerId, itemId, milestoneId) =>
      `/api/requests/ih-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/details`,
    doBulkWorkItemMilestoneUpdate: (requestId, printerId, itemId) =>
      `/api/requests/ih-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones`
  };
  public static duplicateRequest(requestId: string | number) {
    return `/api/requests/${requestId}`;
  }
  public static getRequestDetails(requestId: string | number) {
    return `/api/requests/${requestId}`;
  }
  public static createProofOfPayment(requestId) {
    return `/api/requests/card-production/${requestId}/finance/attachments`;
  }
  public static deleteProofOfPayment(requestId, attachmentId) {
    return `/api/requests/card-production/${requestId}/finance/attachments/${attachmentId}`;
  }
  public static fsCreateProofOfPayment(requestId) {
    return `api/requests/financial-services/${requestId}/details/proofs-of-payment`;
  }
  public static fsDeleteProofOfPayment(requestId, attachmentId) {
    return `/api/requests/financial-services/${requestId}/details/proofs-of-payment/${attachmentId}`;
  }
  public static bifCreateProofOfPayment(requestId) {
    return `api/requests/bif-production/${requestId}/details/proofs-of-payment`;
  }
  public static bifDeleteProofOfPayment(requestId, attachmentId) {
    return `/api/requests/bif-production/${requestId}/details/proofs-of-payment/${attachmentId}`;
  }
  public static thirdPartyCreateProofOfPayment(requestId) {
    return `api/requests/third-party-production/${requestId}/details/finance-proofs-of-payment`;
  }
  public static thirdPartyCreateOperationsAttachment(requestId) {
    return `api/requests/third-party-production/${requestId}/details/operations-attachments`;
  }
  public static thirdPartyDeleteProofOfPayment(requestId, attachmentId) {
    return `/api/requests/third-party-production/${requestId}/details/finance-proofs-of-payment/${attachmentId}`;
  }
  public static thirdPartyDeleteOperationsAttachment(requestId, attachmentId) {
    return `/api/requests/third-party-production/${requestId}/details/operations-attachments/${attachmentId}`;
  }
  public static thirdPartyUpdateOperationsDetails(requestId) {
    return `api/requests/third-party-production/${requestId}/operations-details`;
  }
  public static thirdPartyUpdateCardCollateralDetails(requestId, itemId) {
    return `/api/requests/third-party-production/${requestId}/items/${itemId}/card-collateral-confirmation-details`;
  }
  public static thirdPartyUpdateConfirmedPrinters(requestId) {
    return `/api/requests/third-party-production/${requestId}/items/confirmed-printers`;
  }
  public static bifUpdatePrinterProofReview(requestId: string | number, itemId: string | number, attachmentId: string | number) {
    return `/api/requests/bif-production/${requestId}/items/${itemId}/printer-proofs/${attachmentId}/review`;
  }
  public static imageCreateArtFile(requestId) {
    return `api/requests/image/${requestId}/art-file/attachments`;
  }
  public static imageDeleteArtFile(requestId, attachmentId) {
    return `/api/requests/image/${requestId}/art-file/attachments/${attachmentId}`;
  }
  public static imageUpdateDesigner = requestId => `/api/requests/image/${requestId}/designer`;
  public static imageUpdateArtFilePath = requestId => `/api/requests/image/${requestId}/final-art-file-path`;
  public static imageSaveTmReview = requestId => `/api/requests/image/${requestId}/tm-review`;
  public static imageUpdateRequestItemsCompleted(requestId) {
    return `api/requests/image/${requestId}/request-items/completed`;
  }
  public static bifPoPdfDownload(requestId, poId, type) {
    return `/api/requests/bif-production/${requestId}/purchase-orders/${poId}/documents/${type}`;
  }
  public static bifPO(requestId) {
    return `/api/requests/bif-production/${requestId}/purchase-orders`;
  }
  public static bifUpdatePO(requestId, poId) {
    return `/api/requests/bif-production/${requestId}/purchase-orders/${poId}`;
  }
  public static createAttachment(requestId) {
    return `/api/requests/card-production/${requestId}/artworks`;
  }
  public static attachmentDownload(requestId, attachmentId) {
    return `/api/requests/${requestId}/attachments/${attachmentId}`;
  }
  public static poPdfDownload(requestId, poId, type) {
    return `/api/requests/card-production/${requestId}/purchase-orders/${poId}/documents/${type}`;
  }
  public static linkAttachment(requestId, requestItemId) {
    return `/api/requests/card-production/${requestId}/details/items/${requestItemId}/artworks`;
  }
  public static deleteArtwork(requestId, attachmentId) {
    return `/api/requests/card-production/${requestId}/artworks/${attachmentId}`;
  }
  public static getRequestId(id, draft = false) {
    return `/api/requests/${id}${draft ? '?draft' : ''}`;
  }
  public static updateRequestName(id) {
    return `/api/requests/${id}/name`;
  }
  public static updateRequestStatus(id) {
    return `/api/requests/${id}/status`;
  }
  public static updatePpm(requestId) {
    return `/api/requests/${requestId}/print-production-manager`;
  }
  public static changeRequestOwner(requestId) {
    return `/api/requests/${requestId}/request-owner`;
  }
  public static changeRequestTrafficManager(requestId) {
    return `/api/requests/${requestId}/traffic-manager`;
  }
  public static refreshProductOwner(requestId: number | string): string {
    return `/api/requests/${requestId}/events/product-owner-refresh`;
  }

  public static changeRequestDesigner(requestId) {
    return `/api/requests/${requestId}/designer`;
  }
  public static changeRequestCreativeDirector(requestId) {
    return `/api/requests/${requestId}/creative-director`;
  }
  public static getWPNdetails(partNumber) {
    return `/api/reference/request/wpn/${partNumber}`;
  }
  public static getMerchantInfo(merchantId) {
    return `/api/reference/request/merchants/${merchantId}/details`;
  }
  public static getRequestSteps(requestId) {
    return `/api/requests/${requestId}/stages`;
  }
  public static managePO(requestId) {
    return `/api/requests/card-production/${requestId}/purchase-orders`;
  }
  public static updatePO(requestId, poId) {
    return `/api/requests/card-production/${requestId}/purchase-orders/${poId}`;
  }
  public static performAction(requestId) {
    return `/api/requests/${requestId}/stages/actions`;
  }
  public static getRequestPrinterWorkItems(requestId) {
    return `/api/requests/card-production/${requestId}/printers/work-items`;
  }
  public static getPopProductionRequestPrinterWorkItems(requestId) {
    return `/api/requests/pop-production/${requestId}/printers/work-items`;
  }
  public static getFsrPrinterWorkItems(requestId) {
    return `/api/requests/financial-services/${requestId}/printers/work-items`;
  }
  public static getBifPrinterWorkItems(requestId) {
    return `/api/requests/bif-production/${requestId}/printers/work-items`;
  }
  public static getThirdProdPrinterWorkItems(requestId) {
    return `/api/requests/third-party-production/${requestId}/printers/work-items`;
  }
  public static updateMilestoneDetails(requestId, printerId, itemId, milestoneId) {
    return `/api/requests/card-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/details`;
  }
  public static updatePopProdMilestoneDetails(requestId, printerId, itemId, milestoneId) {
    return `/api/requests/pop-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/details`;
  }
  public static updateFsrMilestoneDetails(requestId, printerId, itemId, milestoneId) {
    return `/api/requests/financial-services/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/details`;
  }
  public static updateBifMilestoneDetails(requestId, printerId, itemId, milestoneId) {
    return `/api/requests/bif-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/details`;
  }
  public static updateThirdProdMilestoneDetails(requestId, printerId, itemId, milestoneId) {
    // tslint:disable-next-line: max-line-length
    return `/api/requests/third-party-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/details`;
  }
  public static createSowAttachment(reqId, poId) {
    return `/api/requests/card-production/${reqId}/purchase-orders/${poId}/sow/attachments`;
  }
  public static deleteSOWFile(reqId, poId, attachmentId) {
    return `/api/requests/card-production/${reqId}/purchase-orders/${poId}/sow/attachments/${attachmentId}`;
  }
  public static getFile(fileId) {
    return `/api/files/${fileId}`;
  }

  public static createThirdSowAttachment(requestAlternateId, orderAlternateId) {
    return `/api/requests/third-party-production/${requestAlternateId}/purchase-orders/${orderAlternateId}/sow/attachments`;
  }
  public static deleteThirdSowFile(requestAlternateId, orderAlternateId, attachmentId) {
    return `/api/requests/third-party-production/${requestAlternateId}/purchase-orders/${orderAlternateId}/sow/attachments/${attachmentId}`;
  }

  public static createCardProductionWorkItemMilestoneAsn(requestId: string, printerId: number, itemId: number, milestoneId: number) {
    return `/api/requests/card-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files`;
  }

  public static createPopProductionWorkItemMilestoneAsn(requestId: string, printerId: number, itemId: number, milestoneId: number) {
    return `/api/requests/pop-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files`;
  }

  public static createFsrWorkItemMilestoneAsn(requestId: string, printerId: number, itemId: number, milestoneId: number) {
    return `/api/requests/financial-services/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files`;
  }

  public static createBifWorkItemMilestoneAsn(requestId: string, printerId: number, itemId: number, milestoneId: number) {
    return `/api/requests/bif-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files`;
  }

  public static createThirdProdWorkItemMilestoneAsn(requestId: string, printerId: number, itemId: number, milestoneId: number) {
    return `/api/requests/third-party-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files`;
  }

  public static deleteCardProductionWorkItemMilestoneAsn(
    requestId: string,
    printerId: number,
    itemId: number,
    milestoneId: number,
    attachmentId: number
  ) {
    // tslint:disable-next-line: max-line-length
    return `/api/requests/card-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files/${attachmentId}`;
  }

  public static deletePopProductionWorkItemMilestoneAsn(
    requestId: string,
    printerId: number,
    itemId: number,
    milestoneId: number,
    attachmentId: number
  ) {
    // tslint:disable-next-line: max-line-length
    return `/api/requests/pop-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files/${attachmentId}`;
  }

  public static deleteFsrWorkItemMilestoneAsn(
    requestId: string,
    printerId: number,
    itemId: number,
    milestoneId: number,
    attachmentId: number
  ) {
    // tslint:disable-next-line: max-line-length
    return `/api/requests/financial-services/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files/${attachmentId}`;
  }

  public static deleteBifWorkItemMilestoneAsn(
    requestId: string,
    printerId: number,
    itemId: number,
    milestoneId: number,
    attachmentId: number
  ) {
    // tslint:disable-next-line: max-line-length
    return `/api/requests/bif-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files/${attachmentId}`;
  }

  public static deleteThirdProdWorkItemMilestoneAsn(
    requestId: string,
    printerId: number,
    itemId: number,
    milestoneId: number,
    attachmentId: number
  ) {
    // tslint:disable-next-line: max-line-length
    return `/api/requests/third-party-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones/${milestoneId}/asn-files/${attachmentId}`;
  }

  public static doCardProductionBulkWorkItemMilestoneUpdate(requestId: string, printerId: number, itemId: number) {
    return `/api/requests/card-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones`;
  }

  public static doPopProdBulkWorkItemMilestoneUpdate(requestId: string, printerId: number, itemId: number) {
    return `/api/requests/pop-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones`;
  }

  public static doFsrBulkWorkItemMilestoneUpdate(requestId: string, printerId: number, itemId: number) {
    return `/api/requests/financial-services/${requestId}/printers/${printerId}/work-items/${itemId}/milestones`;
  }

  public static doBifBulkWorkItemMilestoneUpdate(requestId: string, printerId: number, itemId: number) {
    return `/api/requests/bif-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones`;
  }

  public static doThirdProdBulkWorkItemMilestoneUpdate(requestId: string, printerId: number, itemId: number) {
    return `/api/requests/third-party-production/${requestId}/printers/${printerId}/work-items/${itemId}/milestones`;
  }

  public static cardProductionUpdateOperationsNotes(requestId) {
    return `api/requests/card-production/${requestId}/printers/details/operations-notes`;
  }

  public static getActionHistory(requestId) {
    return `/api/requests/${requestId}/action-history`;
  }

  public static createAttachmentUploadLink(requestId, fileType) {
    return `/api/requests/${requestId}/attachments/${fileType}/upload-link`;
  }
  public static scanAttachmentUploadFile(uploadId){
    return `/api/requests/attachments/scan-statuses/${uploadId}`;
  }

  public static createArtworkAttachment = requestId => `/api/requests/${requestId}/art-file/attachments`;
  public static deleteArtworkAttachment = (requestId, attachmentId) => `/api/requests/${requestId}/art-file/attachments/${attachmentId}`;

  public static requestDeleteArtworkAttachment(requestId, attachmentId) {
    return `/api/requests/${requestId}/art-file/attachments/${attachmentId}`;
  }
  public static cdUpdateDesigner(requestId) {
    return `/api/requests/card-design/${requestId}/designer`;
  }
  public static cdUpdateCsJobs(requestId) {
    return `/api/requests/card-design/${requestId}/cs-job-id`;
  }
  public static getProductUpc(productUpc) {
    return `/api/reference/request/product/${productUpc}`;
  }
  public static checkReplenishProductUpc(requestId, productUpc, wpn) {
    return `/api/requests/third-party-production/${requestId}/is-replenish/${productUpc}/${wpn}`;
  }
  public static cdUpdateTmDatesApproval(requestId) {
    return `/api/requests/card-design/${requestId}/tm-review`;
  }
  public static cdUpdateFinalArtDueDate = requestId => `/api/requests/card-design/${requestId}/final-art-due`;
  public static cdDeleteItem = (requestId, requestItemId) => `/api/requests/card-design/${requestId}/request-item/${requestItemId}`;
  public static createCardDesignItemArtwork = (requestId: string, requestItemId: number) =>
    `/api/requests/card-design/${requestId}/items/${requestItemId}/artworks`;
  public static createCardDesignArtworkVersion(requestId, requestItemId, artworkFileId) {
    return `/api/requests/card-design/${requestId}/items/${requestItemId}/artworks/${artworkFileId}/versions`;
  }
  public static deleteArtworkItem(requestId, requestItemId, artworkFileId) {
    return `/api/requests/card-design/${requestId}/items/${requestItemId}/artworks/${artworkFileId}`;
  }
  public static cdAddVersionResolution(requestId, requestItemId, artworkFileId, versionId) {
    return `/api/requests/card-design/${requestId}/items/${requestItemId}/artworks/${artworkFileId}/versions/${versionId}/resolution`;
  }

  public static cdTmReview2StageData(requestId) {
    return `/api/requests/card-design/${requestId}/tm-review-2`;
  }
  public static updateArtPathNotes(requestId) {
    return `/api/requests/card-design/${requestId}/request-items/art-path-notes`;
  }
  public static pdUpdateTmDatesApproval = requestId => `/api/requests/pop-design/${requestId}/tm-review`;
  public static pdUpdateFinalArtDueDate = requestId => `/api/requests/pop-design/${requestId}/delivery-date`;
  public static pdDeleteItem = (requestId, requestItemId) => `/api/requests/pop-design/${requestId}/request-item/${requestItemId}`;
  public static pdUpdateDesigner = requestId => `/api/requests/pop-design/${requestId}/designer`;

  public static createPopDesignItemArtwork = (requestId: string, requestItemId: number) =>
    `/api/requests/pop-design/${requestId}/items/${requestItemId}/artworks`;
  public static createPopDesignArtworkVersion(requestId, requestItemId, artworkFileId) {
    return `/api/requests/pop-design/${requestId}/items/${requestItemId}/artworks/${artworkFileId}/versions`;
  }
  public static pdAddVersionResolution(requestId, requestItemId, artworkFileId, versionId) {
    return `/api/requests/pop-design/${requestId}/items/${requestItemId}/artworks/${artworkFileId}/versions/${versionId}/resolution`;
  }

  public static pdTmReview2StageData(requestId) {
    return `/api/requests/pop-design/${requestId}/tm-review-2`;
  }

  public static updateRequestItemWithFinancialServicesProductLines(requestAlternateId: number) {
    return `/api/requests/pop-design/${requestAlternateId}/items/financial-services-product-lines`;
  }
  public static createFinancialServicesArtwork(requestAlternateId: number, itemId: number) {
    return `/api/requests/pop-design/${requestAlternateId}/items/${itemId}/financial-services-artworks`;
  }
  public static deleteFinancialServicesArtworkFile(requestAlternateId: number, itemId: number, attachmentId: number) {
    return `/api/requests/pop-design/${requestAlternateId}/items/${itemId}/financial-services-artworks/${attachmentId}`;
  }
  public static createFinancialServicesExternalArtwork(requestAlternateId: number, itemId: number) {
    return `/api/requests/pop-design/${requestAlternateId}/items/${itemId}/financial-services-external-artworks`;
  }
  public static deleteFinancialServicesExternalArtworkFile(requestAlternateId: number, itemId: number, attachmentId: number) {
    return `/api/requests/pop-design/${requestAlternateId}/items/${itemId}/financial-services-external-artworks/${attachmentId}`;
  }
  public static pdUpdateArtPathNotes(requestId) {
    return `/api/requests/pop-design/${requestId}/request-items/art-path-notes`;
  }
  public static pdDeleteArtworkItem(requestId, requestItemId, artworkFileId) {
    return `api/requests/pop-design/${requestId}/items/${requestItemId}/artworks/${artworkFileId}`;
  }
  public static createPopProductionPartnerAttachments(requestId) {
    return `/api/requests/pop-production/${requestId}/details/partner-art-attachments`;
  }
  public static createPopProductionPrinterQuoteAttachments(requestId) {
    return `/api/requests/pop-production/${requestId}/details/printer-quote-attachments`;
  }
  public static ppRemovePartnerAttachments(requestId, attachmentId) {
    return `/api/requests/pop-production/${requestId}/details/partner-art-attachments/${attachmentId}`;
  }
  public static ppRemovePrinterQuoteAttachments(requestId, attachmentId) {
    return `/api/requests/pop-production/${requestId}/details/printer-quote-attachments/${attachmentId}`;
  }
  public static createPopProductionAdditionalAttachments(requestId) {
    return `/api/requests/pop-production/${requestId}/details/additional-attachments`;
  }
  public static ppRemoveAdditionalAttachments(requestId, attachmentId) {
    return `/api/requests/pop-production/${requestId}/details/additional-attachments/${attachmentId}`;
  }
  public static createPopProductionArtwork(requestId: string) {
    return `/api/requests/pop-production/${requestId}/details/artworks`;
  }
  public static ppDeleteArtwork(requestId: string | number, itemId: string | number | undefined, attachmentId: string | number) {
    return `/api/requests/pop-production/${requestId}/details/artworks/${attachmentId}`;
  }
  public static createPopProductionPrinterProof(requestId: string) {
    return `/api/requests/pop-production/${requestId}/details/printer-proofs`;
  }
  public static ppDeletePrinterProof(requestId: string | number, attachmentId: string | number) {
    return `/api/requests/pop-production/${requestId}/details/printer-proofs/${attachmentId}`;
  }
  public static ppUpdatePrinterProofReview(requestId: string | number, itemId: string | number, attachmentId: string | number) {
    return `/api/requests/pop-production/${requestId}/details/printer-proofs/${attachmentId}/review`;
  }
  public static ppPoPdfDownload(requestId, poId, type) {
    return `/api/requests/pop-production/${requestId}/purchase-orders/${poId}/documents/${type}`;
  }
  public static ppPrinterQuoteStageDownload(requestId) {
    return `/api/requests/pop-production/${requestId}/documents/request-process-printer-quote`;
  }
  public static fsrDetailsStageDownload(requestId) {
    return `/api/requests/financial-services/${requestId}/documents/request-for-quote`;
  }
  public static ppPO(requestId) {
    return `/api/requests/pop-production/${requestId}/purchase-orders`;
  }
  public static ppUpdatePO(requestId, poId) {
    return `/api/requests/pop-production/${requestId}/purchase-orders/${poId}`;
  }
  public static ppUpdateConversionToProduction(requestId: string) {
    return `/api/requests/pop-production/${requestId}/details/production-conversion`;
  }
  public static createFsrArtwork(requestId: string) {
    return `/api/requests/financial-services/${requestId}/details/artworks`;
  }
  public static fsrDeleteArtwork(requestId: string | number, attachmentId: string | number) {
    return `/api/requests/financial-services/${requestId}/details/artworks/${attachmentId}`;
  }
  public static fsrPoPdfDownload(requestId, poId, type) {
    return `/api/requests/financial-services/${requestId}/purchase-orders/${poId}/documents/${type}`;
  }
  public static fsrPO(requestId) {
    return `/api/requests/financial-services/${requestId}/purchase-orders`;
  }
  public static fsrUpdatePO(requestId, poId) {
    return `/api/requests/financial-services/${requestId}/purchase-orders/${poId}`;
  }
  public static fsUpdateArtworkReview(requestId: string | number, itemId: string | number, attachmentId: string | number) {
    return `/api/requests/financial-services/${requestId}/items/${itemId}/artworks/${attachmentId}/review`;
  }
  public static createBifArtwork(requestId: string) {
    return `/api/requests/bif-production/${requestId}/artworks`;
  }
  public static bifDeleteArtwork(requestId: string | number, attachmentId: string | number) {
    return `/api/requests/bif-production/${requestId}/artworks/${attachmentId}`;
  }
  public static createBifPrinterProof(requestId: string) {
    return `/api/requests/bif-production/${requestId}/printer-proofs`;
  }
  public static bifDeletePrinterProof(requestId: string | number, attachmentId: string | number) {
    return `/api/requests/bif-production/${requestId}/printer-proofs/${attachmentId}`;
  }
  public static createBifMatrix(requestId: string) {
    return `/api/requests/bif-production/${requestId}/matrix`;
  }
  public static bifDeleteMatrix(requestId: string | number, attachmentId: string | number) {
    return `/api/requests/bif-production/${requestId}/matrix/${attachmentId}`;
  }
  public static createThirdPartyArtwork(requestId: string) {
    return `api/requests/third-party-production/${requestId}/details/artworks`;
  }
  public static thirdPartyDeleteArtwork(requestId: string | number, attachmentId: string | number) {
    return `api/requests/third-party-production/${requestId}/details/artworks/${attachmentId}`;
  }
  public static thirdProdPo(requestId) {
    return `/api/requests/third-party-production/${requestId}/purchase-orders`;
  }
  public static thirdProdPoPdfDownload(requestId, poId, type) {
    return `/api/requests/third-party-production/${requestId}/purchase-orders/${poId}/documents/${type}`;
  }
  public static thirdProdTpsReportDownload() {
    return `/api/fn/reports/download/third-party-tps-report`;
  }
  public static thirdProdUpdatePO(requestId, poId) {
    return `/api/requests/third-party-production/${requestId}/purchase-orders/${poId}`;
  }
  public static thirdPartyItemPrinters(requestId: string | number) {
    return `/api/requests/third-party-production/${requestId}/spreadsheets/items/printers`;
  }
  public static thirdPartyCreateTps(requestId: string | number) {
    return `/api/requests/third-party-production/${requestId}/spreadsheets`;
  }
  public static thirdPartyGetRequestTps(requestId: string | number) {
    return `/api/requests/third-party-production/${requestId}/spreadsheets`;
  }
  public static thirdPartyDeleteTps(requestId: string | number, tpsId: string | number) {
    return `/api/requests/third-party-production/${requestId}/spreadsheets/${tpsId}`;
  }
  public static thirdPartyBulkUpdateItems(requestId: string | number) {
    return `/api/requests/third-party-production/${requestId}/items/operations-details`;
  }
  public static thirdPartyBulkUpdateCardRanges(requestId: string | number) {
    return `/api/requests/third-party-production/${requestId}/items/operations-details/card-ranges`;
  }
  public static thirdPartyBulkUpdateCC(requestId: string | number) {
    return `/api/requests/third-party-production/${requestId}/card-collateral-confirmation-details`;
  }
  /**
   * @deprecated
   */
  public static createIHProductionItemArtwork(requestId: string, itemId: number) {
    return `/api/requests/ih-production/${requestId}/items/${itemId}/artworks`;
  }
  public static createIHProductionArtwork(requestId: string) {
    return `/api/requests/ih-production/${requestId}/artworks`;
  }
  /**
   * @deprecated
   */
  public static ihProductionDeleteItemArtwork(requestId: string | number, itemId: string | number, attachmentId: string | number) {
    return `/api/requests/ih-production/${requestId}/items/${itemId}/artworks/${attachmentId}`;
  }

  public static ihProductionDeleteArtwork(requestId: string | number, attachmentId: string | number) {
    return `/api/requests/ih-production/${requestId}/artworks/${attachmentId}`;
  }

  /**
   * IH Production Request
   */
  public static ihProdPo(requestId) {
    return `/api/requests/ih-production/${requestId}/purchase-orders`;
  }
  public static ihProdPoPdfDownload(requestId, poId, type) {
    return `/api/requests/ih-production/${requestId}/purchase-orders/${poId}/documents/${type}`;
  }
  public static ihProdUpdatePO(requestId, poId) {
    return `/api/requests/ih-production/${requestId}/purchase-orders/${poId}`;
  }
  public static createIhPrinterProof(requestId: string) {
    return `/api/requests/ih-production/${requestId}/printer-proofs`;
  }
  public static ihDeletePrinterProof(requestId: string | number, attachmentId: string | number) {
    return `/api/requests/ih-production/${requestId}/printer-proofs/${attachmentId}`;
  }
  public static ihUpdatePrinterProofReview(requestId: string | number, itemId: string | number, attachmentId: string | number) {
    return `/api/requests/ih-production/${requestId}/items/${itemId}/printer-proofs/${attachmentId}/review`;
  }
  public static createIhMatrix(requestId: string) {
    return `/api/requests/ih-production/${requestId}/matrix`;
  }
  public static ihDeleteMatrix(requestId: string | number, attachmentId: string | number) {
    return `/api/requests/ih-production/${requestId}/matrix/${attachmentId}`;
  }

  static substitutes() {
    return `/api/users/substitutes`;
  }

  static substitute(substituteUsername: string) {
    return `/api/users/substitutes/${substituteUsername}`;
  }

  static adminSubstitute(username: string, substituteUsername: string) {
    return `/api/admin/users/substitutes/${username}/${substituteUsername}`;
  }

  static adminSubstitutes(username?: string) {
    if (username == null) {
      return `/api/admin/users/substitutes`;
    }
    return `/api/admin/users/substitutes/${username}`;
  }

  static emailTps() {
    return `/api/fn/reports/email/tps`;
  }

  static emailTpsTemplates() {
    return `/api/requests/third-party-production/spreadsheets/email-templates`;
  }

  static userSettings() {
    return `/api/users/profiles/settings`;
  }

  static userEmailSignature() {
    return `/api/users/profiles/settings/email-signature`;
  }

  static cardDesignPrepArtifactsDesigner(requestId: number): string {
    return `/api/requests/card-design/${requestId}/prep-artifacts-designer`;
  }

  static popDesignPrepArtifactsDesigner(requestId: number): string {
    return `/api/requests/pop-design/${requestId}/prep-artifacts-designer`;
  }
  static editAdditionalOtherContacts(requestNumber) {
    return `/api/requests/${requestNumber}/contacts`;
  }
  static getPDFTronKey() {
    return `/api/public/admin/pdftron/key`;
  }
}
